// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".description-modal[data-v-32cb9730]{background-color:#fff}.description-modal-body[data-v-32cb9730],.description-modal-title[data-v-32cb9730]{padding:0 2rem 2rem}.description-modal-close[data-v-32cb9730]{padding:.5rem;display:flex;justify-content:flex-end}.description-modal-close .close-circle-icon[data-v-32cb9730]{color:#939393}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
